import React from "react";
import styled from "styled-components";

import { Divider, CenterMe } from "../reusable/layout";
import { ModalTitle, Box, InputUI } from "../reusable/components";
import { exportControlledURL, exportUncontrolledURL } from "./index";

const Container = styled.div`
  margin-top: 0px;
`;

export default p => (
  <Container>
    <Box>
      <ModalTitle>
        <h2>Uncontrolled Mode</h2>
        <Divider h="15px" />
        <p>
          You need to import each scene individually and your broadcasting software will be
          responsible for switching scenes.
        </p>
        <Divider h="15px" />
        <div>Here is the URL for the current scene.</div>
      </ModalTitle>
      <Divider h="15px" />
      <CenterMe>
        <InputUI width="90%" value={exportUncontrolledURL()} />
      </CenterMe>
    </Box>
    <Divider h="30px" />
    <Box>
      <ModalTitle>
        <h2>Controlled Mode</h2>
        <Divider h="15px" />
        <p>You will be able to switch scenes using Huds Studio</p>
      </ModalTitle>
      <Divider h="15px" />
      <CenterMe>
        <InputUI width="90%" value={exportControlledURL()} />
      </CenterMe>
    </Box>
  </Container>
);



// WEBPACK FOOTER //
// ./src/user/export.js